<template>
    <f-dialog
        title   ="Datei Umbennen"
        v-model = "value"
        :width  = "460"
        @cancel = "onCancel"
        @store  = "onSave"
    >
        <template v-slot:content>
            <v-text-field
                v-model        = "editname"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
            />
        </template>
    </f-dialog>
</template>

<script>

import FDialog from "@/modules/core/components/utils/FDialog.vue";
export default {
    name: "PDmsRename",
    components: {
        FDialog
    },

    props: {
        value: {

        },

        filename: {

        }
    },

    data: () => ({
        editname: null
    }),

    mounted() {
        this.editname = this.filename;
    },

    watch: {
        filename () {
            this.editname = this.filename;
        }
    },

    methods: {
        onCancel () {
            this.$emit("input", false)
        },

        onSave () {
            this.$emit("input", false)
            this.$emit("save", this.editname)
        }
    }
}
</script>

<style scoped>

</style>